import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref } from 'vue';

import {
  HeadingDisplay,
  ContentDisplay,
  Heading,
  BaseText,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { IWithdrawDetails } from '@/modules/transaction/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Preview',
  setup(__props) {

const fetchWithdraw = inject('fetchWithdraw', () => ({}));

const withdrawDetails = inject('withdrawDetails') as Ref<IWithdrawDetails>;

const isFetchingWithdraw = inject('isFetchingWithdraw') as Ref<boolean>;
const amountFormatted = inject('amountFormatted') as Ref<string>;

const title = computed(() => {
  return `R$ ${amountFormatted.value}`;
});

const contentFooter = computed(() => {
  return 'A solicitação de resgate é baseada no valor bruto. Isso significa que o total líquido poderá ser alterado devido à variação das cotas no dia em que a operação for concluída, considerando impostos e taxas. Qualquer dúvida, fale com o seu especialista.';
});

const previewDetails = computed(() => {
  return [
    {
      label: 'Liquidação prevista',
      value: withdrawDetails.value.expectedRedemptionDate
    },
    {
      label: 'Origem',
      value: withdrawDetails.value.portfolioName
    },
    {
      label: 'Destino',
      value: 'Conta'
    }
  ];
});

return { __sfc: true,fetchWithdraw, withdrawDetails, isFetchingWithdraw, amountFormatted, title, contentFooter, previewDetails, HeadingDisplay, ContentDisplay, Heading, BaseText, ListDisplay, ButtonContainer, ButtonPrimary }
}

})